import React from 'react';
import Table from '../Table/Table';
import style from './Return.module.css';

const Return = ({ return_of_company }) => {

  if (return_of_company === null ) {
    return (
      <div>
        <h3 className={style.headline}>Return</h3>
        <p className={style.noData}>No data</p>
      </div>
    );
  }

  return (
    <div>
      <h3 className={style.headline}>Return</h3>
      <div>
        <Table>
          <tbody>
            <tr>
              <th>Return on Equity</th>
              <td className={style.points}>
                {return_of_company?.["return_on_equity"] ? Number((return_of_company["return_on_equity"])*100).toFixed(2)+"%" : "-"}
              </td>
            </tr>
            <tr>
              <th>Return on Assets</th>
              <td className={style.points}>
                {return_of_company?.["return_on_assets"] ? Number((return_of_company["return_on_assets"])*100).toFixed(2)+"%"  : "-"}
              </td>
            </tr>
            <tr>
              <th>Return on Invested Capital</th>
              <td className={style.points}>
                {return_of_company?.["return_on_capital"] ? Number((return_of_company["return_on_capital"])*100).toFixed(2)+"%"  : "-"}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default Return;